import { useEffect, useMemo, useState } from "react";
import { LanguageContext, dict } from "../i18n";

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState("pt");
    const t = dict[lang];

    useEffect(() => {
        document.title = t.meta.title;
        document.documentElement.lang = lang === "pt" ? "pt-BR" : "en";
    }, [lang, t]);

    const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
}
